import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-34985086"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "container"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Mensajería", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Añadir amigos", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "search-form" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_11 = {
  class: "userMessage",
  style: {"margin-right":"10px"}
}
const _hoisted_12 = { class: "image" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  style: {"float":"right"},
  class: "glass"
}

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import { ref, onMounted,Ref } from 'vue'
import { useAuth } from '@/store/useAuth';
import AddFriend from '@/components/widgets/AddFriend.vue';
import FriendshipService from '@/services/FriendshipService'
import FullConversationChat from '@/components/widgets/FullConversationChat.vue';
import ConversationNotification from '@/components/widgets/ConversationNotification.vue';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'MessagesView',
  setup(__props) {

const loading = ref(true)
const store = useAuth()
const showAddFriend = ref(false)
const friends:Ref<any> = ref({})
const filteredFriends:Ref<any>  = ref([])
const friendshipService = new FriendshipService()
const search = ref('')
const friendId = ref(0)
const showConversationBox = ref(false)
const router = useRoute()
const paramId = router.params.id

onMounted(async () => {
    if (!store.token) {
        loading.value = false
        return
    }
    loading.value = true
    friends.value = await friendshipService.listUserFriends(store.token)
    filteredFriends.value = friends.value
    if(paramId) {
        showConversation(paramId)
    }
    loading.value = false
})

const showConversation = async (id:any) => {
    if (!store.token) {
        return
    }
    friendId.value = id;
    await friendshipService.markAsRead(store.token, id)
    showConversationBox.value = true
}

const closeConversation = () => {
    showConversationBox.value = false
}

const handleSearch = () => {
    loading.value = true
    filteredFriends.value = friends.value.filter((item:any) => item.name.toLowerCase().includes(search.value.toLowerCase()))
    loading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (showConversationBox.value)
              ? (_openBlock(), _createBlock(FullConversationChat, {
                  key: 0,
                  friendId: friendId.value,
                  onCloseConversation: closeConversation
                }, null, 8, ["friendId"]))
              : _createCommentVNode("", true),
            (showAddFriend.value)
              ? (_openBlock(), _createBlock(AddFriend, {
                  key: 1,
                  onClose: _cache[0] || (_cache[0] = ($event: any) => (showAddFriend.value = false))
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _hoisted_5,
              _createElementVNode("button", {
                class: "friend",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showAddFriend.value = true))
              }, [
                _createVNode(_component_v_icon, {
                  name: "io-person-add-sharp",
                  class: "icon",
                  hover: "true",
                  animation: "wrench",
                  fill: "white"
                }),
                _hoisted_6
              ])
            ]),
            _hoisted_7,
            _createElementVNode("form", _hoisted_8, [
              _createVNode(_component_v_icon, { name: "fa-filter" }),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search).value = $event)),
                placeholder: "Filtrar búsqueda",
                onKeyup: handleSearch
              }, null, 544), [
                [_vModelText, search.value]
              ])
            ]),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredFriends.value, (friend) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: friend.id,
                  style: {"margin":"2px"},
                  class: "liMessages",
                  onClick: ($event: any) => (showConversation(friend.id))
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        (friend?.profile_picture_uri)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: friend.profile_picture_uri
                            }, null, 8, _hoisted_13))
                          : (_openBlock(), _createElementBlock("h3", _hoisted_14, _toDisplayString(friend.name.substring(0,2)), 1))
                      ])
                    ]),
                    _createElementVNode("p", null, _toDisplayString(friend.name), 1)
                  ]),
                  _createElementVNode("button", _hoisted_15, [
                    _createVNode(ConversationNotification, {
                      friendId: friend.id,
                      style: {"position":"absolute"}
                    }, null, 8, ["friendId"]),
                    _createVNode(_component_v_icon, {
                      name: "bi-chat-fill",
                      scale: "1.5",
                      fill: "white"
                    })
                  ])
                ], 8, _hoisted_9))
              }), 128))
            ])
          ]))
    ]),
    _: 1
  }))
}
}

})